import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { RefreshCw, CheckCircle2, ArrowRight, AlertTriangle } from 'lucide-react';
import { useLang } from '../i18n';
import { Card, Button, Spinner, Reveal, Badge } from '../components/ui';
import api, { vnd } from '../api';

export default function Renew() {
  const { policyId } = useParams();
  const { t } = useLang();
  const nav = useNavigate();
  const [state, setState] = useState('working'); // working | done | error
  const [result, setResult] = useState(null);

  useEffect(() => {
    api.post(`/policies/${policyId}/renew`)
      .then((r) => { setResult(r.data); setState('done'); })
      .catch(() => setState('error'));
  }, [policyId]);

  return (
    <div className="max-w-xl mx-auto px-5 py-16" data-testid="renew-page">
      <Reveal>
        <Card className="p-8 text-center">
          {state === 'working' && (
            <><RefreshCw className="w-10 h-10 text-jade mx-auto mb-4 animate-spin" />
            <div className="text-slate-300">{t('renewing')}</div></>
          )}
          {state === 'done' && result && (
            <>
              <CheckCircle2 className="w-12 h-12 text-jade mx-auto mb-4" />
              <h1 className="font-display text-2xl font-bold">{t('renewed_ok')}</h1>
              <div className="mt-2 text-slate-400">{result.policy.policy_no} · {result.policy.vehicle.make} {result.policy.vehicle.model}</div>
              <div className="flex items-center justify-center gap-3 mt-5">
                <div className="text-sm text-slate-400 line-through">{vnd(result.old_premium_vnd)}</div>
                <ArrowRight className="w-4 h-4 text-jade" />
                <div className="font-display text-2xl font-extrabold text-jade" data-testid="renew-new-premium">{vnd(result.new_premium_vnd)}</div>
              </div>
              <div className="text-xs text-slate-500 mt-2">{t('valid_until')} {result.policy.end_date.slice(0, 10)}</div>
              <Button data-testid="renew-go-wallet" onClick={() => nav('/carry')} className="mt-6">{t('go_wallet')} <ArrowRight className="w-4 h-4" /></Button>
            </>
          )}
          {state === 'error' && (
            <><AlertTriangle className="w-10 h-10 text-amber mx-auto mb-4" />
            <div className="text-slate-300">Could not renew this policy.</div>
            <Button variant="ghost" onClick={() => nav('/carry')} className="mt-5">{t('go_wallet')}</Button></>
          )}
        </Card>
      </Reveal>
    </div>
  );
}
